import type { AuditLogEntry } from '@/entities/admin/model/adminSchema';

const EXTRA_KEY = 'ohs-arm-audit-extra';
const MAX_ENTRIES = 80;

function formatAuditNow(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function getExtraAuditEntries(): AuditLogEntry[] {
  try {
    const raw = localStorage.getItem(EXTRA_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as AuditLogEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function appendAuditEntry(entry: Omit<AuditLogEntry, 'id' | 'datetime'> & { datetime?: string }): void {
  const list = getExtraAuditEntries();
  const id = Date.now() + Math.floor(Math.random() * 1000);
  const datetime = entry.datetime ?? formatAuditNow();
  list.unshift({
    id,
    datetime,
    user: entry.user,
    action: entry.action,
  });
  localStorage.setItem(EXTRA_KEY, JSON.stringify(list.slice(0, MAX_ENTRIES)));
}
